<template>
    <b-card>
      <div>
        <b-row class="mb-2">
          <b-col sm="3" class="text-sm-right">
            <b>{{$t('label_evaluation_administrator_model_name')}}</b>: 
          </b-col>
          <b-col v-if="row.item.evaluation_administrator_model_name">
            {{row.item.evaluation_administrator_model_name}}
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col sm="3" class="text-sm-right">
            <b>{{$t('label_evaluation_administrator_model_shortName')}}</b>: 
          </b-col>
          <b-col v-if="row.item.evaluation_administrator_model_shortName">
            {{row.item.evaluation_administrator_model_shortName}}
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col sm="3" class="text-sm-right">
            <b>{{$t('label_evaluation_administrator_model_version')}}</b>: 
          </b-col>
          <b-col v-if="row.item.evaluation_administrator_model_version">
            {{row.item.evaluation_administrator_model_version}}
          </b-col>
        </b-row>
                <b-row class="mb-2">
          <b-col sm="3" class="text-sm-right">
            <b>{{$t('label_evaluation_administrator_model_activeStatus')}}</b>: 
          </b-col>
          <b-col v-if="row.item.isActive">{{$t('label_evaluation_administrator_model_active')}}</b-col>
          <b-col v-else> {{$t('label_evaluation_administrator_model_inactive')}}</b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col sm="3" class="text-sm-right">
            <b>{{$t('label_evaluation_administrator_sealPercentagesRequired')}}</b>: 
          </b-col>
          <b-col>
            <span>{{$t('label_evaluation_bronze')}}: {{row.item.evaluation_bronze}}%</span>
            <span style="margin-left:75px">{{$t('label_evaluation_silver')}}: {{row.item.evaluation_silver}}%</span>
            <span style="margin-left:75px">{{$t('label_evaluation_gold')}}: {{row.item.evaluation_gold}}%</span>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col sm="3" class="text-sm-right">
            <b>{{$t('evaluation_administrator_model_creationDate')}}</b>: 
          </b-col>
          <b-col v-if="row.item.evaluation_administrator_model_version">
            {{row.item.createdAt}}
          </b-col>
        </b-row>
      </div>
        <b-col class="text-right">
          <b-btn variant="primary" size="sm" @click="$emit('click')">
              {{ $t("label_evaluation_administrator_hideDetails_button") }}
          </b-btn>
        </b-col>
    </b-card>
</template>

<script>
export default {
  name: "EvaluationModelInfoCard",
  props: {
    row: {
      type: Object,
      default: {},
    }
  },
}
</script>